import React from "react";
import "./kiosk-cf-ui.scss";
import cln from "classnames";
import tick from "mytime-common/custom-fields/common/checkbox-tick.svg";

export const kioskCfUi = (ui) => ({
    theme_color: ui.theme_color,
    inputCln: "kiosk-cf-input",
    textNormalCln: "kiosk-cf-text-normal",
    toggleCln: "kiosk-cf-toggle",
    renderErrorBlock: (msg) => (
        <div className="kiosk-cf-error-block">
            {msg}
        </div>
    ),
    textPlaceholderCln: "kiosk-cf-text-placeholder",
    restrictWidthCln: null,
    calendarNavBtnCln: "kiosk-cf-calendar-nav-btn",
    dropdownOptionCln: "kiosk-cf-dropdown-option",
    renderCheckboxLine: ({control, label, key, onClick}) => (
        <div className="kiosk-cf-checkbox-line" key={key} onClick={onClick}>
            <div className="control">
                {control}
            </div>

            <div className="label">
                {label}
            </div>
        </div>
    ),

    renderCheckbox: (checked) => (
        <div
            className={cln("kiosk-cf-checkbox", {checked})}
            style={checked ? {
                background: ui.theme_color
            } : {}}
        >
            {!!checked && (
                <img src={tick} alt="tick"/>
            )}
        </div>
    ),
});